import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useProjectId } from '~src/hooks/useProjectId';
import { useCurrentFolder } from '~src/hooks/useCurrentFolder';
import { useIsProjectEmpty } from '~src/hooks/useIsProjectEmpty';
import { useIsSuperuser } from '~src/hooks/useIsSuperuser';
import { useIsPath } from '~src/hooks/useIsPath';

export const useRightSideViewState = () => {
  const projectId = useProjectId();

  const history = useHistory();

  const paths = history.location.pathname.split('/').filter(Boolean);
  const tenderId = paths[3];
  const isFirstLevel = !paths[6];

  const currentFolder = useCurrentFolder();
  const folderId = currentFolder?.id || null;

  const permissionLevel = currentFolder?.permission || 0;

  const isProjectEmpty = useIsProjectEmpty();
  const isSuperuser = useIsSuperuser();
  const isOnArchive = useIsPath('/archive');
  const isOnTender = useIsPath('/tenders');
  const isOnMyTender = useIsPath('/my-tenders');
  const isOnShares = useIsPath('/shares');
  const isOnDetails = useIsPath('/details');
  const isOnMovements = useIsPath('/movements');
  const isOnOffers = useIsPath('/offers');
  const isOnContract = useIsPath('/contract');
  const isOnQA = useIsPath('/questions');

  const [shareModal, setShareModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [restoreToModal, setRestoreToModal] = useState(false);
  const [folderEditModal, setFolderEditModal] = useState(false);
  const [moveModal, setMoveModal] = useState(false);
  const [folderPropertiesModal, setFolderPropertiesModal] = useState(false);
  const [fileEditModal, setFileEditModal] = useState(false);
  const [folderRightsModal, setFolderRightsModal] = useState(false);
  const [itemLogModal, setItemLogModal] = useState(false);
  const [createFolderModal, setCreateFolderModal] = useState(false);
  const [correlationLetterModal, setCorrelationLetterModal] = useState(false);
  const [reactivateShare, setReactivateShareModal] = useState(false);
  const [attachmentEditModal, setAttachmentEditModal] = useState(false);

  const modalsFunc = {
    share: setShareModal,
    'folder-edit': setFolderEditModal,
    'folder-move': setMoveModal,
    'folder-properties': setFolderPropertiesModal,
    'rights-managment': setFolderRightsModal,
    'file-edit': setFileEditModal,
    'file-move': setMoveModal,
    'item-log': setItemLogModal,
    'folder-create': setCreateFolderModal,
    delete: setDeleteModal,
    restore: setRestoreToModal,
    correlationLetter: setCorrelationLetterModal,
    reactivateShare: setReactivateShareModal,
    attachmentEditModal: setAttachmentEditModal,
  };

  return {
    projectId,
    tenderId,
    isFirstLevel,
    currentFolder,
    folderId,
    permissionLevel,
    isProjectEmpty,
    isSuperuser,
    isOnArchive,
    isOnTender,
    isOnMyTender,
    isOnShares,
    isOnMovements,
    isOnDetails,
    isOnOffers,
    isOnContract,
    isOnQA,

    modals: {
      modalsFunc,

      setShareModal,
      shareModal,
      setFolderEditModal,
      folderEditModal,
      setMoveModal,
      moveModal,
      setFolderPropertiesModal,
      folderPropertiesModal,
      setFolderRightsModal,
      folderRightsModal,
      setFileEditModal,
      fileEditModal,
      setItemLogModal,
      itemLogModal,
      setCreateFolderModal,
      createFolderModal,
      setDeleteModal,
      deleteModal,
      setRestoreToModal,
      restoreToModal,
      setCorrelationLetterModal,
      correlationLetterModal,
      setReactivateShareModal,
      reactivateShare,
      attachmentEditModal,
      setAttachmentEditModal,
    },
  };
};
